import {DropDownList as KendoDropDownList} from '@progress/kendo-react-dropdowns';
import KendoHOC from "./utils/KendoHOC";

const DropDown = (options) => (KendoHOC(KendoDropDownList, options));

export default DropDown;
